// client/src/components/TiptapEditor/MenuBar/ListGroup.js
import React from "react";

export const ListGroup = ({ editor }) => {
  const buttons = [
    {
      name: "bulletList",
      action: () => editor.chain().focus().toggleBulletList().run(),
      label: "Viñetas",
    },
    {
      name: "orderedList",
      action: () => editor.chain().focus().toggleOrderedList().run(),
      label: "Numerada",
    },
  ];

  return (
    <>
      {buttons.map((button) => (
        <button
          key={button.name}
          type="button"
          onClick={button.action}
          className={editor.isActive(button.name) ? "is-active" : ""}
        >
          {button.label}
        </button>
      ))}
    </>
  );
};
